<header mat-dialog-title>
    <a class="back-button href-btn" fxHide.lt-md (click)="cancel()">&lt; Back</a>
    <h1>Add Customer</h1>
</header>
<form [formGroup]="customerForm" (ngSubmit)="saveCustomer()">
    <div class="customer-info customerContainer" mat-dialog-content>
        <mat-card class="block-info">
            <mat-card-header>
                <mat-card-title><h2>Customer Info</h2></mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>
                    <mat-form-field appearance="outline" *letVar="fields.firstName as field">
                        <mat-label>First Name</mat-label>
                        <input
                            matInput
                            id="firstName"
                            type="text"
                            placeholder="First Name"
                            formControlName="firstName"
                            required
                            [errorStateMatcher]="errorMatcher"
                        />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" *letVar="fields.lastName as field">
                        <mat-label>Last Name</mat-label>
                        <input
                            matInput
                            id="lastName"
                            type="text"
                            placeholder="Last Name"
                            formControlName="lastName"
                            required
                            [errorStateMatcher]="errorMatcher"
                        />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline" *letVar="fields.email as field">
                        <mat-label>Email</mat-label>
                        <input
                            matInput
                            id="email"
                            type="email"
                            lowercase-inp
                            placeholder="Email"
                            formControlName="email"
                            required
                            [errorStateMatcher]="errorMatcher"
                        />
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </p>
                <p>
                    <phone-input label="Phone Number" [theForm]="customerForm" field="phone" notRequired="true"></phone-input>
                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number Type</mat-label>
                        <select
                            matNativeControl
                            id="phoneType"
                            formControlName="phoneType"
                            placeholder="-- Select phone type --"
                            [errorStateMatcher]="errorMatcher"
                        >
                            <option *ngFor="let type of phoneTypeList" [value]="type">{{ type }}</option>
                        </select>
                    </mat-form-field>
                </p>
                <p>
                    <phone-input label="Phone Number 2" [theForm]="customerForm" field="phone2" notRequired="true"></phone-input>
                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number 2 Type</mat-label>
                        <select
                            matNativeControl
                            id="phoneType"
                            formControlName="phone2Type"
                            placeholder="-- Select phone 2 type --"
                            [errorStateMatcher]="errorMatcher"
                        >
                            <option *ngFor="let type of phoneTypeList" [value]="type">{{ type }}</option>
                        </select>
                    </mat-form-field>
                </p>
                <p>
                    <phone-input label="Phone Number 3" [theForm]="customerForm" field="phone3" notRequired="true"></phone-input>
                    <mat-form-field appearance="outline">
                        <mat-label>Phone Number 3 Type</mat-label>
                        <select
                            matNativeControl
                            id="phoneType"
                            formControlName="phone3Type"
                            placeholder="-- Select phone 3 type --"
                            [errorStateMatcher]="errorMatcher"
                        >
                            <option *ngFor="let type of phoneTypeList" [value]="type">{{ type }}</option>
                        </select>
                    </mat-form-field>
                </p>
                <p>
                    <mat-form-field appearance="outline">
                        <mat-label>Account Number</mat-label>
                        <input matInput id="accountNumber" placeholder="Account Numberr" formControlName="accountNumber" />
                    </mat-form-field>
                </p>
            </mat-card-content>
        </mat-card>
        <mat-card class="block-info">
            <mat-card-header>
                <mat-card-title><h2>Admin Info</h2></mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p *ngIf="entities$ | async as entities">
                    <mat-form-field appearance="outline" *letVar="fields.entityId as field">
                        <mat-label>Company</mat-label>
                        <select matNativeControl id="entityId" formControlName="entityId" required [errorStateMatcher]="errorMatcher">
                            <option value="" selected>Select a company</option>
                            <option *ngFor="let entity of entities" [value]="entity.id">{{ entity.name }}</option>
                        </select>
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </p>
            </mat-card-content>
        </mat-card>
    </div>
    <mat-card-actions class="formActionButtonGroup clearfix" mat-dialog-actions>
        <a mat-stroked-button id="cancel" [disabled]="submitAttempted" (click)="cancel()"> Cancel </a>
        <button mat-raised-button color="primary" class="new-primary-button" [disabled]="submitAttempted" type="submit">Save</button>
    </mat-card-actions>
</form>
